const storageKey = 'duo-grid-area-ticket-ids';

const getTicketIds = (): string[] => {
  try {
    return JSON.parse(localStorage.getItem(storageKey) ?? '[]');
  } catch {
    return [];
  }
};

export const rememberDuoGridAreaTickets = (ticketIds: string[]) => {
  const ids = [...new Set([...getTicketIds(), ...ticketIds])].slice(-100);
  localStorage.setItem(storageKey, JSON.stringify(ids));
};

export const isDuoGridAreaTicket = (ticketId: string) =>
  getTicketIds().includes(ticketId);

export const forgetDuoGridAreaTicket = (ticketId: string) => {
  localStorage.setItem(
    storageKey,
    JSON.stringify(getTicketIds().filter((id) => id !== ticketId)),
  );
};
